<template>
  <LocaleSwitchDropdown
    :locales="availableLocales"
    :current-locale="currentLocale"
    :aria-label="$ts('languageSwitch.selectLanguage')"
    :search-placeholder="$ts('languageSwitch.searchLanguages')"
    :no-results-text="$ts('languageSwitch.noLanguagesFound')"
    :dark="dark"
    :compact="compact"
    :globe="globe"
    :show-search="showSearch"
    :expand-direction="expandDirection"
    :dropdown-align="dropdownAlign"
    :class="$props.class"
    @select="handleSelect"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '#imports';
import LocaleSwitchDropdown from '#bubba/shared/components/ui/language-selector/LocaleSwitchDropdown.vue';

const props = withDefaults(
  defineProps<{
    class?: string;
    showSearch?: boolean;
    expandDirection?: 'up' | 'down' | 'auto';
    dark?: boolean;
    compact?: boolean;
    globe?: boolean;
    dropdownAlign?: 'left' | 'right';
  }>(),
  {
    showSearch: false,
    expandDirection: 'auto',
    dark: false,
    compact: false,
    globe: false,
    dropdownAlign: 'left',
  },
);

const { $getLocale, $getLocales, $switchLocale, $ts } = useI18n();

const currentLocale = computed(() => $getLocale());
const availableLocales = computed(() =>
  $getLocales() as Array<{ code: string; name?: string; nativeName?: string }>,
);

const handleSelect = (code: string) => {
  $switchLocale(code);
};
</script>
